import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './DashboardDemo.css';
import close from '../../assets/design/dashboard/close.png';
import DeclinedPopup from './DeclinedPopup';
import RescheduleTimes from '../../components/qualifier/RescheduleTimes';
import CalendarLinks from '../../components/qualifier/CalendarLinks';
import { getSeoName } from '../../utils/utils';
import moment from 'moment-timezone';
import FadeIn from '../../utils/fadein';
import Spinner from '../../components/layout/Spinner';
import { FaTimes, FaEllipsisV, FaRegCalendar, FaRegCalendarAlt, FaRegQuestionCircle } from 'react-icons/fa';
import { getBuyerDemosPending, getBuyerDemosInvited, getUserProfile, hasAvailableApplications, createSellerDemo, addCompanyClick, uet, getDemoAvailableTimes, approveStandaloneDemo } from '../../utils/api';
import { refresh } from '../../services/auth.service';
import { ArrowRight, Coins, Check } from 'lucide-react';
import QualifierQuestions from '../../components/qualifier/QualifierQuestions';
import SubmitTimes from '../../components/qualifier/SubmitTimes';
import SubmitReschedule from '../../components/qualifier/SubmitReschedule';
import { format, eachHourOfInterval, parseISO, isValid, isAfter, setHours, setMinutes, setSeconds, startOfDay, endOfDay } from 'date-fns';

const BuyerDemos_Invited = ({ buyerDeclinedReasons }) => {
  const [showCompanyInfo, setShowCompanyInfo] = useState(false);
  const [currentDemo, setCurrentDemo] = useState({});
  const [showFutureDemoNotice, setShowFutureDemoNotice] = useState(false);
  const [showMeetingDetails, setShowMeetingDetails] = useState(false);
  const [showDeclinedPopup, setShowDeclinedPopup] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [hasDemos, setHasDemos] = useState(true);
  const [showJoin, setShowJoin] = useState(true); // 11.17.2022 - show join button
  const [loaded, setLoaded] = useState(false);
  const [demos, setDemos] = useState([]);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showStatusInfo, setShowStatusInfo] = useState(false);
  const [workEmailVerified, setWorkEmailVerified] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [userProfile, setUserProfile] = useState({});
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [showMaxReached, setShowMaxReached] = useState(false);
  const [hasAvailable, setHasAvailable] = useState(false);
  const [currentDemoId, setCurrentDemoId] = useState(null);
  const [showQualifier, setShowQualifier] = useState(false);
  const [showSelectedTime, setShowSelectedTime] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [showWorkEmailPopup, setShowWorkEmailPopup] = useState(false);
  const [showRecommended, setShowRecommended] = useState(false);
  const [showDemoApproval, setShowDemoApproval] = useState(false);
  const [statusInfoPosition, setStatusInfoPosition] = useState({ x: 0, y: 0 });
  const [availableTimes, setAvailableTimes] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedTimeId, setSelectedTimeId] = useState(null);
  const baseimageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;

  const navigate = useNavigate();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const imageUrl = process.env.REACT_APP_IMAGE_URL;


  async function handleQualifierClick(demo_id, item, version = 1) {
    console.log('item', item);
    let _check = await hasAvailableApplications();

    if (_check.success) {
      if (_check.data === true) {
        setShowMaxReached(false);
        setHasAvailable(true);
      }

      else {
        setHasAvailable(false);
        setShowMaxReached(true);
        //setBookingLoading(false);
        return;
      }
    }

    setCurrentDemo(item);
    setSubmitting(true);

    let data = { seller_id: item.seller_id };
    let _res = await createSellerDemo(data);

    if (_res.success) {
      setCurrentDemoId(_res.data);
      setShowQualifier(true);
      setSubmitting(false);
    }

    else {
      setCurrentDemoId(_res.demo_id);
      setShowQualifier(true);
      setSubmitting(false);
    }

    await uet('Dashboard buyer recommendation', item.company_id);

    if (version == 1)
      await addCompanyClick(item.company_id, 'Dashboard recommendations (A version)');

    else if (version == 2) {
      await addCompanyClick(item.company_id, 'Dashboard recommendation (B version)');
    }
  }

    async function handleShowDemoApproval(demo_id, item, version = 1) {
    console.log('item', item);
    setCurrentDemoId(demo_id);
    setCurrentDemo(item);
    let res = await getDemoAvailableTimes(demo_id);

    if (res.success){
      setAvailableTimes(res.data);
    }

    setShowDemoApproval(true);
  }

  async function handleBook(item) {
    setSelectedRecommendation(item);
    setShowWorkEmailPopup(true);
    setShowRecommended(true);
  }

  async function handleSelectTime(time, timeId) {
    setSelectedTime(time);
    setSelectedTimeId(timeId);
    //setShowSelectedTime(true);
  }

  useEffect(() => {
    async function loadUserProfile() {
      let res = await getUserProfile();

      if (res.success) {
        setProfileLoaded(true);
        setUserProfile(res.data);
        setWorkEmailVerified(res.data.work_email_verified);
      } else if (res.status === 403) {
        await refresh();
        let res = await getUserProfile();

        if (res.success) {
          setProfileLoaded(true);
          setUserProfile(res.data);
          setWorkEmailVerified(res.data.work_email_verified);
        }
      }
    }

    loadUserProfile();
  }, []);

   async function loadDemos() {
      let res = await getBuyerDemosInvited();

      if (res.success) {
        setDemos(res.data);
        setLoaded(true);
      }

      else if (res.status === 403) {
        await refresh();
        let res = await getBuyerDemosInvited();

        if (res.success) {
          setDemos(res.data);
          setLoaded(true);
        }
      }
    }

  useEffect(() => {
    async function loadDemos() {
      let res = await getBuyerDemosInvited();

      if (res.success) {
        setDemos(res.data);
        setLoaded(true);
      }

      else if (res.status === 403) {
        await refresh();
        let res = await getBuyerDemosInvited();

        if (res.success) {
          setDemos(res.data);
          setLoaded(true);
        }
      }
    }

    loadDemos();
  }, []);

  useEffect(() => {
    let _democount = demos.filter(
      (item) =>
        item.seller_status === 'Approved' &&
        item.buyer_status === 'Approved' &&
        item.demo_status === 'Pending'
    ).length;

    if (_democount > 0) {
      setHasDemos(true);
    }
    else
      setHasDemos(false);
  }, [demos]);

  function declinedClickHandle(demo, id) {
    setCurrentDemo(demo);
    setShowDeclinedPopup(true);
    setShowSubMenu(false);
  }

  function formatDate(date) {
    let d = new Date(date);
    let weekDay = d.getDay();
    let day = d.getDate();
    let month = d.getMonth();
    let year = d.getFullYear();
    return weekDays[weekDay] + ', ' + months[month] + ' ' + day + ' ' + year;
  }

  function tFormat(time) {
    time = time.toString();
    const zero = '0';

    if (time.length <= 3) {
      time = zero.concat(time);
      const temp = Array.from(time);
      temp.splice(2, 0, ':');
      const formatted = temp.toString().replace(/,/g, '');
      return formatted;
    } else {
      const temp = Array.from(time);
      temp.splice(2, 0, ':');
      const formatted = temp.toString().replace(/,/g, '');
      return formatted;
    }
  }

  function tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }

  function handleRescheduleClick(item) {
    console.log('item', item);
    setShowMeetingDetails(false);
    setCurrentDemo(item);
    setShowReschedule(true);
    setShowSubMenu(false);
  }

  function getTrimmedString(inputString = '') {

    if (inputString == null) {
      return '';
    }
    const maxLength = 160;
    if (inputString.length <= maxLength) {
      return inputString;
    } else {
      // Truncate the string to the maximum length minus 1 (for the ellipsis)
      // and ensure we don't cut off in the middle of a word.
      let trimmedString = inputString.substr(0, maxLength - 1);
      trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));
      return `${trimmedString}…`;
    }
  }

  const handleStatusInfoClick = (e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setStatusInfoPosition({
      x: rect.x,
      y: rect.bottom + window.scrollY + 5
    });
    setShowStatusInfo(true);
  };

  function demoAccepted() {
    let _filter = demos.filter(item => item.company_id !== currentDemo.company_id);
    setDemos(_filter);
  }

  async function handleRequestDemoApproval(){
    //alert(selectedTime);
    let res = await approveStandaloneDemo(currentDemoId, selectedTime, selectedTimeId);

    if (res.success) {
      setShowDemoApproval(false);
      setShowConfirmation(true);
      demoAccepted();

      loadDemos();
    }
  }

  // click handler to close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setShowStatusInfo(false);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const areAllTimesExpired = () => {
    if (!availableTimes.length) return true;
    const now = new Date();
    return availableTimes.every(time => new Date(time.available_time) < now);
  };

  return (
    <>
      {loaded === false && (
        <Spinner />
      )}

      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Personal Demo Invitations</h1>
        <p className="text-gray-600">
          Review and manage demo requests where companies have specifically invited you to explore their software.
          These are personalized opportunities based on your profile and requirements.
        </p>
      </div>

      {loaded && demos.length === 0 && (
        <div className="bg-white rounded-lg shadow-sm p-8 text-center">
          <div className="mx-auto max-w-md">
            <FaRegCalendar className="mx-auto h-12 w-12 text-gray-400" />
            <h2 className="mt-4 text-xl font-semibold text-gray-900">No demo requests found</h2>
            <p className="mt-2 text-sm text-gray-500">
              When you apply for demos with companies, they'll appear here for you to manage.
            </p>
            <Link
              to="/software"
              className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
            >
              Browse Companies
            </Link>
          </div>
        </div>
      )}

      {loaded == true && demos.length > 0 && (
        <>
          <div className="mb-6 bg-white rounded-lg shadow-sm p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Active Applications</h3>
                <p className="text-sm text-gray-500">You have {demos.length} pending application{demos.length !== 1 ? 's' : ''}</p>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 bg-white shadow-sm rounded-lg">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-medium text-gray-500">Company</th>
                  <th className="px-6 py-4 text-left text-sm font-medium text-gray-500">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {demos.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-start space-x-4">
                        <div className="flex-shrink-0 h-12 w-12 rounded-full overflow-hidden border border-gray-200">
                          <img
                            src={imageUrl + 'tr:di-@@companylogos@@default-buyer.png/' + item.logo}
                            className="h-full w-full object-cover"
                            alt={item.company_name}
                          />
                        </div>

                        <div className="flex-1 min-w-0">
                          <p className="text-sm text-gray-500 truncate">
                            Date sent: {new Date(item.date_created).toLocaleDateString('en-US', {})}
                            </p>
                          <p className="text-lg font-semibold text-gray-900 truncate">{item.company_name}</p>
                          <p className="mt-1 text-sm text-gray-500">{getTrimmedString(item.description)}</p>
                          <Link to={`/company/${item.company_id}/${item.url_slug}`} className="mt-2 inline-flex text-sm font-medium text-purple-600 hover:text-purple-500">
                            View more details
                          </Link>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center space-x-3">
                        {workEmailVerified && (
                          <>
                            {(submitting === false || currentDemo.company_id !== item.company_id) && item.is_standalone == false && (
                              <button
                                onClick={() => handleQualifierClick(item.demo_id, item, 2)}
                                className="inline-flex items-center px-6 py-1 text-base font-medium text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                              >
                                <span>Book Demo</span>
                                <ArrowRight className="ml-2 -mr-1 w-5 h-5" />
                              </button>
                            )}

                            {(submitting === false || currentDemo.company_id !== item.company_id) && item.is_standalone == true && (
                              <button
                                onClick={() => handleShowDemoApproval(item.demo_id, item, 2)}
                                className="inline-flex items-center px-6 py-1 text-base font-medium text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                              >
                                <span>Approve Demo</span>
                                <ArrowRight className="ml-2 -mr-1 w-5 h-5" />
                              </button>
                            )}

                            {submitting && currentDemo.company_id === item.company_id && (
                              <div className='center'>
                                <Spinner />
                              </div>
                            )}
                          </>
                        )}

                        {workEmailVerified === false && (
                          <button
                            onClick={() => handleBook(item)}
                            className="inline-flex items-center px-6 py-1 text-base font-medium text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-full transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                          >
                            <span>Book Demo</span>
                            <ArrowRight className="ml-2 -mr-1 w-5 h-5" />
                          </button>
                        )}

                        <button
                          onClick={() => declinedClickHandle(item, item.demo_id)}
                          className="inline-flex items-center px-6 py-1 text-base font-medium text-gray-700 bg-white hover:bg-gray-50 border border-gray-300 rounded-full transition-all duration-200 hover:shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                          <span>Not Interested</span>
                          <FaTimes className="ml-2 -mr-1 w-4 h-4" />
                        </button>
                      </div>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {showReschedule && (
        <>
          <div className='overlay'>
            <div className='modal modal--pad0 modal--wide'>
              <SubmitReschedule
                demo={currentDemo}
                demos={demos}
                setDemos={setDemos}
                demo_id={currentDemo.demo_id}
                company_name={currentDemo.company_name}
                seller_id={currentDemo.seller_id}
                showSteps={true}
                setShowReschedule={setShowReschedule}
              />

            </div>
          </div>
        </>
      )}

      {showStatusInfo && (
        <>
          <div className='overlay'></div>
          <div
            className="modal bg-white rounded-lg shadow-xl border border-gray-200 p-4"
          >
            <div className='modal__close' onClick={() => setShowStatusInfo(false)}>
              <FaTimes className="h-5 w-5 text-gray-500 hover:text-gray-700 cursor-pointer" />
            </div>

            <div className="text-sm text-gray-600">
              <h4 className="font-medium text-gray-900 mb-2">What does Pending mean?</h4>
              <p className="mb-2">Your demo request is currently being reviewed by the company. They will:</p>
              <ul className="list-disc pl-4 space-y-1">
                <li>Verify your company information</li>
                <li>Review your requirements</li>
                <li>Confirm demo availability</li>
              </ul>
              <p className="mt-2 text-xs text-gray-500">You'll be notified once they approve or decline your request.</p>
            </div>
          </div>
        </>
      )}

      {showDeclinedPopup &&
        (
          <div>
            <DeclinedPopup
              showDeclinedPopup={showDeclinedPopup}
              setShowDeclinedPopup={setShowDeclinedPopup}
              role='Buyer'
              buyerDeclinedReasons={buyerDeclinedReasons}
              currentDemo={currentDemo}
              demos={demos}
              setDemos={setDemos}
              source='Decline'
            />
          </div>
        )}

      {showConfirmation && (
        <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-xl shadow-2xl z-50 p-6">
            <button
              onClick={() => setShowConfirmation(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>

            <div className="flex flex-col items-center">
              {/* Coin Animation */}
              <div className="relative mb-4">
                <div className="absolute inset-0 bg-yellow-100 rounded-full animate-ping opacity-60"></div>
                <div className="relative flex items-center justify-center p-3 bg-yellow-100 rounded-full">
                  <Coins className="h-12 w-12 text-yellow-500" />
                  <span className="absolute -top-1 -right-1 flex items-center justify-center h-6 w-6 bg-green-500 text-white text-sm font-bold rounded-full shadow-lg">
                    +5
                  </span>
                </div>
              </div>

              {/* Success Message */}
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Success!</h2>

              <div className="text-center">
                <div className="bg-green-50 border border-green-100 rounded-lg p-4 mb-6">
                  <p className="text-gray-600">
                    Your request has been submitted and will be reviewed soon. You should hear back within 24 hours.
                  </p>
                </div>

                <button
                  onClick={() => setShowConfirmation(false)}
                  className="px-6 py-2.5 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg font-semibold shadow hover:from-purple-700 hover:to-purple-800 transition-all"
                >
                  Continue Browsing
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {showQualifier && (
        <FadeIn delay={300} duration={300}>
          <div className='overlay'></div>
          <div className='modal modal--pad0 modal--50'>
            <QualifierQuestions currentDemo={currentDemo} demo_id={currentDemoId} setShowQualifier={setShowQualifier} setShowSelectedTime={setShowSelectedTime}></QualifierQuestions>
          </div>
        </FadeIn>
      )}

      {showSelectedTime && (
        <div className='overlay'>
          <div className='modal modal--pad0 modal--wide'>
            <SubmitTimes demo={currentDemo} demo_id={currentDemoId} company_name={currentDemo.company_name} seller_id={currentDemo.seller_id} setShowSelectedTime={setShowSelectedTime} showSteps={false} setShowConfirmation={setShowConfirmation} demoAccepted={demoAccepted} />
          </div>
        </div>
      )}

      {showWorkEmailPopup && (
        <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-xl shadow-2xl z-50 p-6">
            <button
              onClick={() => setShowWorkEmailPopup(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>

            <div className="flex flex-col items-center text-center">
              {/* Email Icon */}
              <div className="mb-4 p-3 bg-blue-100 rounded-full">
                <svg className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Verify Your Work Email
              </h3>

              <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6">
                <p className="text-gray-600">
                  Before booking a demo, we need to verify your work email. This helps ensure high-quality connections with vendors.
                </p>
              </div>

              <div className="text-sm text-gray-500 mb-6">
                It only takes 1-2 minutes to complete the verification process.
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => setShowWorkEmailPopup(false)}
                  className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Cancel
                </button>

                <Link
                  to="/account/work-email"
                  className="px-6 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold shadow hover:from-blue-700 hover:to-blue-800 transition-all"
                >
                  Verify Now
                </Link>
              </div>
            </div>
          </div>
        </>
      )}

      {showMaxReached && (
        <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-xl shadow-2xl z-50 p-6">
            <button
              onClick={() => setShowMaxReached(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>

            <div className="flex flex-col items-center text-center">
              {/* Warning Icon */}
              <div className="mb-4 p-3 bg-amber-100 rounded-full">
                <svg className="h-8 w-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Daily Limit Reached
              </h3>

              <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 mb-6">
                <p className="text-gray-600">
                  You've reached your maximum demo applications for today. This limit helps ensure high-quality interactions with vendors.
                </p>
              </div>

              <div className="text-sm text-gray-500 mb-6">
                Please check back tomorrow to apply for more demos. Your limit will reset at midnight.
              </div>

              <button
                onClick={() => setShowMaxReached(false)}
                className="px-6 py-2.5 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg font-semibold shadow hover:from-amber-600 hover:to-amber-700 transition-all"
              >
                Got it
              </button>
            </div>
          </div>
        </>
      )}

      {showDemoApproval && (
        <>
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50"></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-xl shadow-2xl z-50 p-6">
            <button
              onClick={() => setShowDemoApproval(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FaTimes className="h-5 w-5" />
            </button>

            <div className="flex flex-col items-center text-center">
              <div className="mb-4 p-3 bg-green-100 rounded-full">
                <Check className="h-8 w-8 text-green-600" />
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {areAllTimesExpired() ? 'Available Times Expired' : 'Would you like to approve this demo?'}
              </h3>

              {areAllTimesExpired() ? (
                <>
                  <div className="bg-amber-50 border border-amber-100 rounded-lg p-4 mb-6">
                    <p className="text-gray-600">
                      Sorry, all the available time slots have expired. Please request to reschedule this demo.
                    </p>
                  </div>

                  <div className="flex gap-3 w-full">
                    <button
                      onClick={() => setShowDemoApproval(false)}
                      className="flex-1 px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      Cancel
                    </button>
                    
                    <button
                      onClick={() => {
                        setShowDemoApproval(false);
                        handleRescheduleClick(currentDemo);
                      }}
                      className="flex-1 px-6 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-lg font-semibold shadow hover:from-purple-700 hover:to-purple-800 transition-all"
                    >
                      Need to Reschedule
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="bg-green-50 border border-green-100 rounded-lg p-4 mb-6">
                    <p className="text-gray-600">
                      Select from one of the Available Times below to approve this demo. Once approved, the seller will be notified and can confirm the meeting.
                    </p>
                  </div>

                  <div className="w-full mb-6">
                    <div className="space-y-2">
                      {availableTimes.map((time, index) => {
                        const localDate = new Date(time.available_time);
                        return (
                          <label 
                            key={index}
                            className={`flex items-center p-3 rounded-lg border cursor-pointer transition-all ${
                              selectedTime === time.available_time ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-purple-200'
                            }`}
                          >
                            <input
                              type="radio"
                              name="demoTime"
                              value={time.available_time}
                              checked={selectedTime === time.available_time}
                              onChange={(e) => handleSelectTime(e.target.value, time.demo_available_time_id)}
                              className="w-4 h-4 text-purple-600 border-gray-300 focus:ring-purple-500"
                            />
                            <span className="ml-3 text-gray-700">
                              {localDate.toLocaleDateString(undefined, {
                                weekday: 'long',
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric'
                              })} at {localDate.toLocaleTimeString(undefined, {
                                hour: 'numeric',
                                minute: '2-digit',
                                timeZoneName: 'short'
                              })}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  <div className="flex gap-3 w-full">
                    <button
                      onClick={() => setShowDemoApproval(false)}
                      className="flex-1 px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                    >
                      Cancel
                    </button>
                    
                    <button
                      onClick={() => handleRequestDemoApproval()}
                      disabled={!selectedTime}
                      className={`flex-1 px-6 py-2 rounded-lg font-semibold shadow transition-all ${
                        selectedTime 
                        ? 'bg-gradient-to-r from-purple-600 to-purple-700 text-white hover:from-purple-700 hover:to-purple-800' 
                        : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                      }`}
                    >
                      Approve Demo
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BuyerDemos_Invited;